__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-09-24-1790252403-stable-dev/";